function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import is from "./filter-set.js";

var rs = /*#__PURE__*/function () {
  function rs(t, s) {
    _classCallCheck(this, rs);

    this.xc = t, this.tf = s, this.xc = t, this.tf = s;
  }

  _createClass(rs, [{
    key: "zc",
    value: function zc(t) {
      if (null == this.xc || null == this.tf) return !1;
      var s = t[0],
          i = t[1];
      return s === this.xc && this.tf.zc(i);
    }
  }, {
    key: "bt",
    value: function bt() {
      return {
        e: this.xc,
        pf: this.tf ? this.tf.bt() : null
      };
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new rs(t ? t.event_name : null, t ? is.fromJson(t.property_filters) : null);
    }
  }]);

  return rs;
}();

export { rs as default };